export default __webpack_public_path__ + "static/sugar-stack-logo-with-tagline-white-blue-b967aee94162e95ba75dc83586752f45.svg";